let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9CDY0"), load("8dyWu")]).then(() => parcelRequire('e3FDi'));